import { VoidedObject } from "@/shared/models/voided-object.model";
import { SectionGroup } from "./SectionGroup";
import { AvailabilityTemplateIdNameModel } from "@/modules/Availability/models/AvailibilityIdNameModel";
import { CampusIdName } from "@/modules/Campus/models/CampusIdName.Model";

export class ServiceTemplateModel extends VoidedObject {
  id?: string;
  internalName!: string;
  aliasName?: string;
  description!: string;
  availabilityColor?: string;
  availabilityRecurrent?: number;
  type!: string;
  category!: string;
  cups?: string;
  state!: string;
  fillByStep!: boolean;
  groups?: SectionGroup[];
  sections?: SectionGroup[];
  multipleInstances?: boolean;
  version?: number;
  onlineAppointments!: boolean;
  campus?: string[] | CampusIdName[];
  availabilitiesTemplate?: string[] | AvailabilityTemplateIdNameModel[];
}
